import React from "react";
import {
  Grid,
  Segment,
  Button,
  Menu,
  Header,
  Form,
  Input,
  Modal,
  Radio,
  Checkbox,
  Divider,
} from "semantic-ui-react";
import "../auth.css";
import "../card.css";
import "../sidemenu.css";
import axios from "axios";
import { reactLocalStorage } from "reactjs-localstorage";
import i18n from "../i18n";
import { connect } from "react-redux";
import Menutest from "./menu.js";
import Select from "react-select";
import Table from "react-bootstrap/Table";
import { Pagination } from "semantic-ui-react";
import { SemanticToastContainer, toast } from "react-semantic-toasts";
import "react-semantic-toasts/styles/react-semantic-alert.css";
import ReactTooltip from "react-tooltip";
import { Message, Icon } from "semantic-ui-react";
import { API_BASE_URL } from "../utils/endpoints";

const modapprove = {
  marginTop: 55,
  marginLeft: "30%",
  height: 'auto',
  textAlign: "left",
};

const modaapprove = {
  marginTop: 55,
  marginLeft: "15%",
  height: 'auto',
  textAlign: "right",
};

const mod = {
  marginTop: 150,
  marginLeft: "30%",
  height: 420,
  textAlign: "left",
};

const moda = {
  marginTop: 150,
  marginLeft: "15%",
  height: 420,
  textAlign: "right",
};

const modi = {
  marginTop: 200,
  marginLeft: "40%",
  height: "auto",
  textAlign: "left",
};

const modai = {
  marginTop: 200,
  marginLeft: "15%",
  height: "auto",
  textAlign: "right",
};

const modadd = {
  marginTop: 150,
  marginLeft: "35%",
  height: "auto",
  textAlign: "left",
};

const modadda = {
  marginTop: 150,
  marginLeft: "25%",
  height: "auto",
  textAlign: "right",
};
const filter = {
  marginTop: 150,
  marginLeft: "30%",
  height: "auto",
  textAlign: "left",
  width: 500,
};
const filtera = {
  marginTop: 150,
  marginLeft: "25%",
  height: "auto",
  textAlign: "left",
  width: 500,
};

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};
const customStylesstop = {
  content: {
    width: "40%",
    marginRight: "30%",
    marginLeft: "30%",
    height: "231px",
    marginTop: "6%",
    background: " #fcfcfc !important",
  },
};
var type = "";

class RequestBalance extends React.Component {
  test(value) {
    var d = new Date(value),
      dformat =
        [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
        " " +
        [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
    return dformat;
  }

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      personssearch: [],
      modalIsOpen: false,
      type: "",
      balance: "",
      from: "",
      totalpage: 1,
      activePage: 1,
      filterTotalpage:1,
      displayViewBox:false,
      searchtotalpage:1,

      fromDate: "",
      toDate: "",

      showStore: true,
      sender: "",
      show: false,
      idRecord: "",
      typeRecord: "",
      exportFlag:false,
      modalIsOpenStop: false,
      modalIsOpenReject: false,
      valueRecord: "",
      balance_type: "",
      emailTo: "",
      account_status_value: false,
      isArabic: false,
      superOperator: false,

      modalOpen: false,
      modalOpenReject: false,
      modalOpenApprove: false,
      modalOpenAdd: false,
      modalOpenFilterDetails: false,
      hideApprove :false,

      SearchWord: "",

      status: "",


      //-------------------------Add Request-------------------------------//
      type_request: [
        { label: i18n.t("Sender_ID.label"), value: "Sender ID" },
        { label: i18n.t("Balance.label"), value: "Balance" },
      ],
      type_request_admin: [
        { label: i18n.t("Sender_ID.label"), value: "Sender ID" },
      ],
      type: [
        { label: "Bulk SMS", value: "bulk_sms" },
        { label: "Profiled SMS", value: "profiled_sms" },
        { label: "LBA SMS", value: "lba_sms" },
        { label: "Survey SMS", value: "survey_sms" },
        { label: "International SMS", value: "international_sms" },
      ],
      balance: 0,
      typeselect: "",
      request: "",
      enable: false,
      isArabic: false,
      show: false,
      flag:'false',
      modalOpenApprovesms: false,


      /**************************************************************** New 10/7/2023 *************************************************************/
      balance_type_request:'',
    };
  }

  handleOpen = () => this.setState({ modalOpen: true });
  handleClose = () => this.setState({ modalOpen: false });

  handleOpenReject = () =>
    this.setState({ modalOpenReject: true, modalOpen: false });
  handleCloseReject = () => this.setState({ modalOpenReject: false });

  handleOpenApprove = () =>
    this.setState({ modalOpenApprove: true, modalOpen: false });
  handleCloseApprove = () => this.setState({ modalOpenApprove: false });

  handleOpenAdd = () => this.setState({ modalOpenAdd: true });
  handleCloseAdd = () => this.setState({ modalOpenAdd: false });

  handleOpenFilterDetails = () =>
    this.setState({ modalOpenFilterDetails: true });
  handleCloseFilterDetails = () =>
    this.setState({ modalOpenFilterDetails: false });

    handleOpenApprovesms = () =>
    this.setState({ modalOpenApprovesms: true});
  handleCloseApprovesms = () => this.setState({ modalOpenApprovesms: false });


  onChangeFromDate = (event) => {
    console.log("First onChangeFromDate")
    const date = new Date(event.target.value);
    const datevalue = date.toLocaleDateString();
    var array = datevalue.split("/");
    var day = array[1];
    var year = array[2];
    const month = date.toLocaleString("default", { month: "short" });
    const timevalue = date.toLocaleTimeString();
    var timearray = timevalue.split(" ");
    var time = timearray[0];
    const fromDate = day + "-" + month + "-" + year + " " + time;
    this.setState({ fromDate: fromDate });
  };
    /******************************** Fast Track 11/7/2023 *************************************/

  
  onChangeFromDate = (event) => {
    

    const date = new Date(event.target.value);

    const datevalue = date.toLocaleDateString();
    console.log(datevalue);
    var array = datevalue.split("/");
    var day = array[1];
    var year = array[2];
    const month = date.toLocaleString("default", { month: "short" });
    const timevalue = date.toLocaleTimeString();
    var timearray = timevalue.split(" ");
    var time = timearray[0];
    
  
    var timees = timevalue.split(":");
    var time_1 =timees[0];

    if(timearray[1]=="PM"){
      time_1=Number(time_1)+12
    }else if(timearray[1]=="AM"){
      if(time_1<10){
      time_1=0+time_1}
    }

   // const fromDate = day + "-" + month + "-" + year + " " + time_1+":"+timees[1]+":"+timees[2];
   const fromDate = day + "-" + month + "-" + year + " " + "00"+":"+"00"+":"+"59";

    this.setState({ fromDate: fromDate });
  
  };

 

  /******************************** Fast Track 11/7/2023 *************************************/

  onChangeToDate = (event) => {
    const date = new Date(event.target.value);

    const datevalue = date.toLocaleDateString();
    
    var array = datevalue.split("/");
    var day = array[1];
    var year = array[2];
    const month = date.toLocaleString("default", { month: "short" });
    const timevalue = date.toLocaleTimeString();
    console.log(timevalue,'time')
    var timearray = timevalue.split(" ");
    var time = timearray[0];
    console.log(timearray[1])

  
    var timees = timevalue.split(":");
    var time_1 =timees[0];

    if(timearray[1]=="PM"){
      time_1=Number(time_1)+12
    }else if(timearray[1]=="AM"){
      if(time_1<10){
      time_1=0+time_1}
    }
    

   // const toDate = day + "-" + month + "-" + year + " " + time_1+":"+timees[1]+":"+timees[2];
   const toDate = day + "-" + month + "-" + year + " " + "00"+":"+"00"+":"+"59";
    this.setState({ toDate: toDate });
  };

  filterData= ()=> {
 
    this.setState({ modalOpenFilterDetails: false });
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page_num = 0;
    var data = {};
    var search = "";
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + `/core/corpsms/getrequest?fromDate=${encodeURI(
        this.state.fromDate
      )}&page=${page_num}&toDate=${encodeURI(
        this.state.toDate
      )}&filter=${search}`;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        `/core/corpsms/getrequest?fromDate=${
          this.state.fromDate
        }&page=${page_num}&toDate=${this.state.toDate}&filter=${search}`;
    }
    var headers = { "Content-Type": "application/json", token: token };

    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result.requests != undefined) {
        this.setState({
          data: res.data.result.requests,
          status: res.data.result.requests.status,
        });
   const paginationEl = document.querySelector(".pagination");
        if (paginationEl) {
          paginationEl.style.display = "none";
        }
       
        const filterPaginationEl = document.querySelector(".filterpagination");
        if (filterPaginationEl) {
          filterPaginationEl.style.display = "block";
        }


        this.setState({ data: res.data.result.requests });

        var request = res.data.result.requests;
      }
      var total = Math.ceil(res.data.result.count / 20);

      this.setState({ filterTotalpage: total });
    });
  }

  handlePaginationFilterChange = (e, { activePage }) => {
    this.setState({ activePage });
    
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page_num = activePage - 1;
    var data = {};
    var search = "";
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/corpsms/getrequest?page=" +
        page_num +
        "&filter=" +
        search;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/corpsms/getrequest?page=" +
        page_num +
        "&filter=" +
        search;
    }
    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result.requests != undefined) {
        this.setState({
          data: res.data.result.requests,
          status: res.data.result.requests.status,
        });
        this.setState({ data: res.data.result.requests });
        var total = Math.ceil(res.data.result.count / 20);
        this.setState({ filterTotalpage: total });
      }
    });
  };

  handlePaginationChange = (e, { activePage }) => {
    this.setState({ activePage });
  
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page_num = activePage - 1;
    var data = {};
    var search = "";
    console.log('mee')
    console.log("search",search)
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/corpsms/getrequest?page=" +
        page_num +
        "&filter=" +
        search;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/corpsms/getrequest?page=" +
        page_num +
        "&filter=" +
        search;
    }
    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result.requests != undefined) {
        this.setState({
          data: res.data.result.requests,
          status: res.data.result.requests.status,
        });
        this.setState({ data: res.data.result.requests });

        var request = res.data.result.requests;
      }
      var total = Math.ceil(res.data.result.count / 20);

      this.setState({ totalpage: total });
    });
  };
  myFunction = (x) => {
    if (x.matches) {
      // If media query matches
      // document.querySelector(".icon_logo").style =
      // "float: left;margin-top: 12%; width: 24%;cursor: pointer;margin-left: -5%;";
    } else {
      //document.querySelector(".icon_logo").style =
      //"float: left;margin-top: 1%;width: 5%;cursor: pointer; margin-left: -5%;";
    }
  };
  componentDidMount() {
    var lang = i18n.language;
    if (lang === "ar") {
      this.setState({ isArabic: true });
      const azr2El = document.querySelector(".azr2_fate7_color");
      if (azr2El) {
        azr2El.style.cssText = "float:right;white-space: pre;text-align:right;width: 20%;margin-right: 0px;";
      }
      //document.querySelector(".search_web ").style =
      //"margin-right: 61%; margin-top: 1%;";
      //   document.querySelector(".icon2 ").style = "float:left !important;";
      const tableEl = document.querySelector(".table");
      if (tableEl) {
        tableEl.style.cssText = "width: 95%;margin-right: 2.5%;";
      }
      //  document.querySelector(".th_child").style = "text-align: right;";
      //document.querySelector(".th_child1").style = "text-align: right;";
      //document.querySelector(".th_child2").style = "text-align: right;";
      //document.querySelector(".th_child3").style = "text-align: right;";
      //document.querySelector(".th_child4").style = "text-align: right;";
      //document.querySelector(".th_child5").style = "text-align: right;";
      const fixedRequestEl = document.querySelector(".fixed_request");
      if (fixedRequestEl) {
        fixedRequestEl.style.cssText = "margin-right: 0% !important;";
      }

      var x = window.matchMedia("(max-width: 700px)");
      this.myFunction(x);
    }
    if (
      reactLocalStorage.get("role") === "ROLE_OPERATOR" ||
      reactLocalStorage.get("role") === "ROLE_OPERATOR_INT"
    ) {
      //document.querySelector(".icon_logo").style = "display:none";
    }
    if (
      reactLocalStorage.get("role") === "ROLE_SUBADMIN" ||
      reactLocalStorage.get("role") === "ROLE_ADMIN"
    ) {
      this.setState({ showStore: false });
    }
  }
  componentWillMount() {
    //----------- from add reques page ------------//
    var lang = i18n.language;
    this.setState({flag:'false'})
    if (lang === "ar") {
      this.setState({ isArabic: true });
    }

    //---------------------------------------//

    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page_num = this.state.activePage - 1;
    var data = {};
    var search = "";
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/corpsms/getrequest?page=" +
        page_num +
        "&filter=" +
        search;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/corpsms/getrequest?page=" +
        page_num +
        "&filter=" +
        search;
    }

    var headers = { "Content-Type": "application/json", token: token };
    axios.get(apiBaseUrl, { headers: headers }).then((res) => {
      if (res.data.result.requests != undefined) {
        if(res.data.result.count===0){
          this.setState({exportFlag:false})
        }else{
          this.setState({exportFlag:true})
        }
        this.setState({ data: res.data.result.requests });

        var request = res.data.result.requests;
        
          const paginationEl = document.querySelector(".pagination");
        if (paginationEl) {
          paginationEl.style.display = "none";
        }
       
        const filterPaginationEl = document.querySelector(".filterpagination");
        if (filterPaginationEl) {
          filterPaginationEl.style.display = "block";
        }
      }
      var total = Math.ceil(res.data.result.count / 20);

      this.setState({ totalpage: total });
    });

    var email = reactLocalStorage.get("email_login");
  }

  openModal() {
    this.setState({ modalIsOpenStop: true });
  }

  afterOpenModal() {
    this.subtitle.style.color = "#f00";
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
    //document.querySelector(".fixed_header").style = "z-index:9";
  }
  

  searchchange = (event) => {
   this.setState({flag:'true'})
    if (event.target.value.length >= 2) {
      this.setState({ SearchWord: event.target.value });
      var token = reactLocalStorage.get("accessToken");

      
      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      var page_num = 0;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/corpsms/searchRequest?page=" +
          page_num +
          "&filter=" +
          event.target.value;
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "/core/corpsms/searchRequest?page=" +
          page_num +
          "&filter=" +
          event.target.value;
      }

      var headers = { "Content-Type": "application/json", token: token };
      axios.get(apiBaseUrl, { headers: headers }).then((res) => {
        var total = Math.ceil(res.data.result.count/20)
        // document.querySelector(".pagination").style = "disp";
        // document.querySelector(".searchpagination").style = "display:block";
        // document.querySelector(".filterpagination").style = "display:none"
        this.setState({ totalpage: total});
        console.log(total)
        this.setState({ data: res.data.result.request});
      });
   
    }
    else{
    if (event.target.value === "") {
        
        this.setState({flag:'false'})
        ////////////////// call the willmount again //////////////////////////
        var token = reactLocalStorage.get("accessToken");
        var ip = API_BASE_URL;
        var s2 = "localhost:3000";
        var apiBaseUrl;
        var page_num = this.state.activePage - 1;
        var data = {};
        var search = "";
        if (ip.includes(s2)) {
          apiBaseUrl =
            API_BASE_URL + "/core/corpsms/getrequest?page=" +
            page_num +
            "&filter=" +
            search;
        } else {
          apiBaseUrl =
            API_BASE_URL +
            "/core/corpsms/getrequest?page=" +
            page_num +
            "&filter=" +
            search;
        }
  
        var headers = { "Content-Type": "application/json", token: token };
        axios.get(apiBaseUrl, { headers: headers }).then((res) => {
          if (res.data.result.requests != undefined) {
            this.setState({ data: res.data.result.requests });
  
            var request = res.data.result.requests;
          
          }
          var total = Math.ceil(res.data.result.count / 20);
  
          this.setState({ totalpage: total });
        });
  
        
      }
    }

  };


    handlePaginationSearchChange = (e, { activePage }) => {
      this.setState({ activePage })
    
      var token = reactLocalStorage.get("accessToken");
      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      var page_num = activePage - 1;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/corpsms/searchRequest?page=" +
          page_num +
          "&filter=" +
          this.state.SearchWord;
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "/core/corpsms/searchRequest?page=" +
          page_num +
          "&filter=" +
          this.state.SearchWord;
      }

      var headers = { "Content-Type": "application/json", token: token };
      axios.get(apiBaseUrl, { headers: headers }).then((res) => {
        var total = res.data.result.count;
        this.setState({ totalpage:Math.ceil(res.data.result.count / 20)});
        this.setState({ data: res.data.result.request });
      });
    
  };
  viewdataApprove = (
    id,
    confirm_id,
    invalid_numbers_count,
    valid_numbers_count,
    total_messages,
    balance_reserved,
    status,
    content
  ) => {
    this.setState({ modalOpenApproveSMS: true });
    var token = reactLocalStorage.get("accessToken");
    this.setState({idRecord:id})
    this.setState({ confirm_id: confirm_id});
    this.setState({ invalid_numbers_count: invalid_numbers_count });
    this.setState({valid_numbers_count:valid_numbers_count})
    this.setState({ total_messages: total_messages });
    this.setState({ content: content });
    if(balance_reserved.profiled_sms){
      this.setState({
        balance_reserved:balance_reserved.profiled_sms,
        messageType: 'Profiled_SMS'
      })
    }
    if(balance_reserved.lba_sms){
      this.setState({
        balance_reserved:balance_reserved.lba_sms,
        messageType: 'LBA_SMS'
      })
    }
    if(balance_reserved.international_sms){
      this.setState({
        balance_reserved:balance_reserved.international_sms,
        messageType: 'International_SMS'
      })
    }
    if(balance_reserved.bulk_sms){
      this.setState({
        balance_reserved:balance_reserved.bulk_sms,
        messageType: 'Bulk_SMS'
      })
    }
   
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page_num = this.state.activePage - 1;
    var data = {};
    var search = "";
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/corpsms/getrequest?page=" +
        page_num +
        "&filter=" +
        search;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/corpsms/getrequest?page=" +
        page_num +
        "&filter=" +
        search;
    }

  
    if (status == "pending") {
      
    }
    if (status == "Approved") {
      this.setState({ modalOpenApproveSMS: false });
      toast({
        type: "warning",
        title: i18n.t("warning.label"),
        description: i18n.t("the_request_has_been_approved.label"),
        animation: "bounce",
        time: 5000,
      });
    }
    if (status == "Rejected") {
      toast({
        type: "warning",
        title: i18n.t("warning.label"),
        description: i18n.t("the_request_has_been_Rejected.label"),
        animation: "bounce",
        time: 5000,
      });
      this.setState({ modalOpenApproveSMS: false });
    }
    if (status == "pending") {
      this.setState({ modalOpenApproveSMS: true });
    }


  }



  viewdata = (
    event,
    balance_type,
    type,
    name,
    type_select,
    email,
    to,
    adv,
    status
  ) => {
    this.setState({ modalOpen: true });
    console.log(adv,'adv')
    
    if(to=='zainUniCam' && type=="sender_id"){
     
      this.setState({
        hideApprove:true
      })
    }else{
      this.setState({
        hideApprove:false
      })
    }
    var token = reactLocalStorage.get("accessToken");
    var id = event;
    var type_select = type_select;
    var name = name;
    var balance_type = balance_type;
    var emailTo = email;
    var adv = adv;
    this.setState({ account_status_value: adv });
    this.setState({ typeRecord: type_select });
    this.setState({ idRecord: id });
    this.setState({ balance_type: balance_type });
    this.setState({ valueRecord: name });
    this.setState({ emailTo: emailTo });
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    var page_num = this.state.activePage - 1;
    var data = {};
    var search = "";
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/corpsms/getrequest?page=" +
        page_num +
        "&filter=" +
        search;
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/corpsms/getrequest?page=" +
        page_num +
        "&filter=" +
        search;
    }

    var i;
    var headers = { "Content-Type": "application/json", token: token };
    if (status == "pending") {
      axios.get(apiBaseUrl, { headers: headers }).then((res) => {
        for (i = 0; i < res.data.result.requests.length; i++) {
          if (res.data.result.requests[i].id === id) {

            /********************************************************* New 10/7/2023 ***************************************************************/
            this.setState({ from: res.data.result.requests[i].from });
            this.setState({ sender: res.data.result.requests[i].value });
            this.setState({ type: res.data.result.requests[i].balance_type });
            this.setState({ modalIsOpen: true });
            this.setState({balance_type_request:res.data.result.requests[i].balance_type })
            /*************************************************************************************************************************************/

           /* if (res.data.result.requests[i].type === "sender_id") {
              this.setState({ from: res.data.result.requests[i].from });
              this.setState({ sender: res.data.result.requests[i].value });
              this.setState({ modalIsOpen: true });
              // document.querySelector(".sender_data").style = "display:block";
              // document.querySelector(".fixed_header").style = "z-index:-1";
            } else {
              // document.querySelector(".fixed_header").style = "z-index:9";
              this.setState({ from: res.data.result.requests[i].from });
              this.setState({ type: res.data.result.requests[i].balance_type });

              this.setState({ balance: res.data.result.requests[i].value });
              this.setState({ modalIsOpen: true });
             
              
            }*/
          }
        }
      });
    }
    if (status == "Approved") {
      this.setState({ modalOpen: false });
      toast({
        type: "warning",
        title: i18n.t("warning.label"),
        description: i18n.t("the_request_has_been_approved.label"),
        animation: "bounce",
        time: 5000,
      });
    }
    if (status == "Rejected") {
      toast({
        type: "warning",
        title: i18n.t("warning.label"),
        description: i18n.t("the_request_has_been_Rejected.label"),
        animation: "bounce",
        time: 5000,
      });
      this.setState({ modalOpen: false });
    }
    if (status == "pending") {
      this.setState({ modalOpen: true });
    }
  };
  reject = (event) => {
    event.preventDefault();
    this.setState({ modalIsOpenReject: true });
  };
  rejectRequest = (event) => {
    var x = this;
    event.preventDefault();
    var id = this.state.idRecord;
    var type = this.state.typeRecord;
    var value = this.state.valueRecord;
    var balance_type = this.state.balance_type;

    var data = {};

    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/corpsms/updaterequest/" +
        id +
        "/Rejected";
    } else {
      apiBaseUrl =
        API_BASE_URL +
        "/core/corpsms/updaterequest/" +
        id +
        "/Rejected";
    }
    var headers = {
      "Content-Type": "application/json",
      token: token,
    };
    axios
      .post(apiBaseUrl, data, { headers: headers })
      .then(response=> {
        if (response.status === 200) {
          if (response.data.status === "success") {
            window.location = "RequestBalance";
          }
        } else if (response.status === 204) {
          console.log("Something wrong");
        } else {
          console.log("Something wrong");
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  approve = (event) => {
    event.preventDefault();
    this.setState({ modalIsOpenStop: true });
  };
  confirmRequest = (event) => {
    var id = this.state.idRecord;
    var type = this.state.typeRecord;
    var value = this.state.valueRecord;
    console.log(value,'value');
    var balance_type = this.state.balance_type;
    var email = this.state.emailTo;

    if (reactLocalStorage.get("role") === "ROLE_OPERATOR") {
      if (type === "sender_id") {
        var x = this;

        var token = reactLocalStorage.get("accessToken");
        const user = {
          sender_id: this.state.sender_id,
          isAdv: this.state.adv,
        };
        var data = user;

        var ip = API_BASE_URL;
        var s2 = "localhost:3000";
        var apiBaseUrl;
        if (ip.includes(s2)) {
          apiBaseUrl =
            API_BASE_URL + "/core/user/rest/senderid/createSenderId";
        } else {
          apiBaseUrl =
            API_BASE_URL + "/core/user/rest/senderid/createSenderId";
        }
        var headers = {
          "Content-Type": "application/json",
          token: token,
        };
        axios
          .post(apiBaseUrl, data, { headers: headers })
          .then(function(response) {
            if (response.status === 200) {
              console.log(response.data.status);
              //      if (response.data.status === 'status') {
              var data = {};

              var token = reactLocalStorage.get("accessToken");
              var ip = API_BASE_URL;
              var s2 = "localhost:3000";
              var apiBaseUrl;
              if (ip.includes(s2)) {
                apiBaseUrl =
                  API_BASE_URL + "/core/corpsms/updaterequest/" +
                  id +
                  "/Approved";
              } else {
                apiBaseUrl =
                  API_BASE_URL +
                  "/core/corpsms/updaterequest/" +
                  id +
                  "/Approved";
              }
              var headers = {
                "Content-Type": "application/json",
                token: token,
              };
              axios
                .post(apiBaseUrl, data, { headers: headers })
                .then(response=> {
                  if (response.status === 200) {
                    if (response.data.status === "success") {
                      window.location = "RequestBalance";
                    }
                    if (response.data.status === "failed") {
                      console.log('heel');
                      toast({
                        type: "warning",
                        title: "Warning",
                        description:
                          response.data.result.ErrorDescription,
                        animation: "bounce",
                        time: 5000,
                      });
                    }
                  } else if (response.status === 204) {
                    console.log("Something wrong");
                  } else {
                    console.log("Something wrong");
                  }
                });
              //   }
            }
          });
      }
    } else if (
      type === "sender_id" &&
      reactLocalStorage.get("role") !== "ROLE_OPERATOR"
    ) {
      var token = reactLocalStorage.get("accessToken");

      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/senderid/getSenderIds";
      } else {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/senderid/getSenderIds";
      }

      var headers = { "Content-Type": "application/json", token: token };
      axios.get(apiBaseUrl, { headers: headers }).then((res) => {
        if (res.data.result != undefined) {
          var i;
          var array =[];
          for (i = 0; i < res.data.result.sender_ids.length; i++) {
            console.log(res.data.result.sender_ids[i].sender_id,value);
           
          
            array.push(res.data.result.sender_ids[i].sender_id);
          
           
            
           /*  if (res.data.result.sender_ids[i].sender_id === value) {
              var x = this;

              var token = reactLocalStorage.get("accessToken");
              const user = {
                sender_id: this.state.sender_id,
                isAdv: this.state.adv,
              };
              var data = user;

              var ip = API_BASE_URL;
              var s2 = "localhost:3000";
              var apiBaseUrl;
              if (ip.includes(s2)) {
                apiBaseUrl =
                  API_BASE_URL + "/core/user/rest/senderid/createSenderId";
              } else {
                apiBaseUrl =
                  API_BASE_URL +
                  "/core/user/rest/senderid/createSenderId";
              }
              var headers = {
                "Content-Type": "application/json",
                token: token,
              };
              axios
                .post(apiBaseUrl, data, { headers: headers })
                .then(function(response) {
                  if (response.status === 200) {
                    if (response.data.status) {
                      var data = {};

                      var token = reactLocalStorage.get("accessToken");
                      var ip = API_BASE_URL;
                      var s2 = "localhost:3000";
                      var apiBaseUrl;
                      if (ip.includes(s2)) {
                        apiBaseUrl =
                          API_BASE_URL + "/core/corpsms/updaterequest/" +
                          id +
                          "/Approved";
                      } else {
                        apiBaseUrl =
                          API_BASE_URL +
                          "/core/corpsms/updaterequest/" +
                          id +
                          "/Approved";
                      }
                      var headers = {
                        "Content-Type": "application/json",
                        token: token,
                      };
                      axios
                        .post(apiBaseUrl, data, { headers: headers })
                        .then(response=> {
                          if (response.status === 200) {
                            if (response.data.status === "success") {
                              x.setState({ modalIsOpenStop: false });
                              x.setState({ modalIsOpen: false });
                              window.location = "RequestBalance";
                            }
                            if (response.data.status === "failed") {
                              toast({
                                type: "warning",
                                title: "Warning",
                                description:
                                  response.data.result.ErrorDescription,
                                animation: "bounce",
                                time: 5000,
                              });
                            }
                          } else {
                            console.log("Something wrong");
                            toast({
                              type: "error",
                              title: i18n.t("error.label"),
                              description: i18n.t("Something_wrong.label"),
                              animation: "bounce",
                              time: 5000,
                            });
                          }
                        });
                    }
                  }
                })
                .catch(function(error) {
                  console.log(error);
                });
            }
            else if (res.data.result.sender_ids[i].sender_id !== value) {
              toast({
                type: "error",
                title: i18n.t("error.label"),
                description: i18n.t("you_do_not_have_this_sender_id.label"),
                animation: "bounce",
                time: 5000,
              });
            } */
          }
          console.log(array,'array');
          if(array.includes(value)){
            console.log('hello');
            var x = this;

            var token = reactLocalStorage.get("accessToken");
            const user = {
              sender_id: this.state.sender_id,
              isAdv: this.state.adv,
            };
            var data = user;

            var ip = API_BASE_URL;
            var s2 = "localhost:3000";
            var apiBaseUrl;
            if (ip.includes(s2)) {
              apiBaseUrl =
                API_BASE_URL + "/core/user/rest/senderid/createSenderId";
            } else {
              apiBaseUrl =
                API_BASE_URL +
                "/core/user/rest/senderid/createSenderId";
            }
            var headers = {
              "Content-Type": "application/json",
              token: token,
            };
            axios
              .post(apiBaseUrl, data, { headers: headers })
              .then(function(response) {
                if (response.status === 200) {
                  if (response.data.status) {
                    var data = {};

                    var token = reactLocalStorage.get("accessToken");
                    var ip = API_BASE_URL;
                    var s2 = "localhost:3000";
                    var apiBaseUrl;
                    if (ip.includes(s2)) {
                      apiBaseUrl =
                        API_BASE_URL + "/core/corpsms/updaterequest/" +
                        id +
                        "/Approved";
                    } else {
                      apiBaseUrl =
                        API_BASE_URL +
                        "/core/corpsms/updaterequest/" +
                        id +
                        "/Approved";
                    }
                    var headers = {
                      "Content-Type": "application/json",
                      token: token,
                    };
                    axios
                      .post(apiBaseUrl, data, { headers: headers })
                      .then(response=> {
                        if (response.status === 200) {
                          console.log('mee');
                          if (response.data.status === "success") {
                            x.setState({ modalIsOpenStop: false });
                            x.setState({ modalIsOpen: false });
                            window.location = "RequestBalance";
                          }
                          if (response.data.status === "failed") {
                            console.log('heel');
                            toast({
                              type: "warning",
                              title: "Warning",
                              description:
                                response.data.result.ErrorDescription,
                              animation: "bounce",
                              time: 5000,
                            });
                          }
                        } else {
                          console.log("Something wrong");
                          toast({
                            type: "error",
                            title: i18n.t("error.label"),
                            description: i18n.t("Something_wrong.label"),
                            animation: "bounce",
                            time: 5000,
                          });
                        }
                      });
                  }
                }
              })
              .catch(function(error) {
                console.log(error);
              });
          }else{
            console.log('no contain');
            toast({
              type: "error",
              title: i18n.t("error.label"),
              description: i18n.t("you_do_not_have_this_sender_id.label"),
              animation: "bounce",
              time: 5000,
            });
          }
        }
      });
    } else if (
      type === "balance" &&
      reactLocalStorage.get("role") != "ROLE_OPERATOR"
    ) {
      var token = reactLocalStorage.get("accessToken");

      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/balance/getBalance/" +
          reactLocalStorage.get("user_id_login");
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "/core/user/rest/balance/getBalance/" +
          reactLocalStorage.get("user_id_login");
      }

      var headers = { "Content-Type": "application/json", token: token };
      axios.get(apiBaseUrl, { headers: headers }).then((res) => {
        const data = res.data.result.balances;
        var i;
        console.log(Object.keys(data));
        var balance_type_data = Object.keys(data);
        if (data) {
          var used;
          var reserved;
          var balance;
          var newbalance;
          var BalanceArray=[];
          //  for (i = 0; i < data.length; i++) {
          for (const key of balance_type_data) {
            BalanceArray.push(key)
            console.log(balance_type,key);
            
          }
         
          if(BalanceArray.includes(balance_type)){
            used = data.bulk_sms.used;
              reserved = data.bulk_sms.reserved;
              balance = data.bulk_sms.balance;
              if (used != undefined && reserved != undefined) {
                newbalance = balance - used - reserved;
              } else if (used === undefined && reserved === undefined) {
                newbalance = data.bulk_sms.balance;
              } else if (reserved != undefined) {
                newbalance = data.bulk_sms.balance - data.bulk_sms.reserved;
              } else if (used != undefined) {
                newbalance = data.bulk_sms.balance - data.bulk_sms.used;
              }

              if (newbalance >= value) {
                var x = this;
                var datanew = {};

                var token = reactLocalStorage.get("accessToken");
                var ip = API_BASE_URL;
                var s2 = "localhost:3000";
                var apiBaseUrl;
                if (ip.includes(s2)) {
                  apiBaseUrl =
                    API_BASE_URL + "/core/corpsms/updaterequest/" +
                    id +
                    "/Approved";
                } else {
                  apiBaseUrl =
                    API_BASE_URL +
                    "/core/corpsms/updaterequest/" +
                    id +
                    "/Approved";
                }
                var headers = {
                  "Content-Type": "application/json",
                  token: token,
                };
                axios
                  .post(apiBaseUrl, datanew, { headers: headers })
                  .then(response=> {
                    if (response.status === 200) {
                      if (response.data.status === "success") {
                        window.location = "RequestBalance";
                      }
                      if (response.data.status === "failed") {
                        
                        toast({
                          type: "warning",
                          title: "Warning",
                          description:
                            response.data.result.ErrorDescription,
                          animation: "bounce",
                          time: 5000,
                        });
                      }
                    } else if (response.status === 204) {
                      console.log("Something wrong");
                    } else {
                      console.log("Something wrong");
                    }
                  })
                  .catch(function(error) {
                    console.log(error);
                  });
              } else {
                toast({
                  type: "error",
                  title: i18n.t("error.label"),
                  description: i18n.t("you_do_not_have_balance.label"),
                  animation: "bounce",
                  time: 5000,
                });
              }
          }else{
            toast({
              type: "error",
              title: i18n.t("error.label"),
              description: i18n.t(
                "you_do_not_have_this_type_of_balance.label"
              ),
              animation: "bounce",
              time: 5000,
            });
          }
        }
      });
    }
  };
  exportData = (e) => {
  //  document.querySelector(".viewBox").style = "display:block;margin-top: 20%;";
  this.setState({
    displayViewBox:true
  })

    var token = reactLocalStorage.get("accessToken");
    var user_id = reactLocalStorage.get("user_id_login");
    var user_name = reactLocalStorage.get("email_login");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (reactLocalStorage.get("role") === "ROLE_OPERATOR") {
      var collectionName = "corpsms_request";
      var query = {
        file_id: user_id,
        toUserName: reactLocalStorage.get("userNameLoggedIN"),
        to: "zainUniCam",
      };
      query = encodeURI(JSON.stringify(query));
      var x = this;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/Export/" +
          collectionName +
          "?query=" +
          query;
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "/core/user/rest/Export/" +
          collectionName +
          "?query=" +
          query;
      }
    } else {
      var collectionName = "corpsms_request";
      var query = {
        file_id: user_id,
        toUserName: reactLocalStorage.get("userNameLoggedIN"),
        fromUserName: reactLocalStorage.get("userNameLoggedIN"),
      };
      query = encodeURI(JSON.stringify(query));
      var x = this;
      if (ip.includes(s2)) {
        apiBaseUrl =
          API_BASE_URL + "/core/user/rest/Export/" +
          collectionName +
          "?query=" +
          query;
      } else {
        apiBaseUrl =
          API_BASE_URL +
          "/core/user/rest/Export/" +
          collectionName +
          "?query=" +
          query;
      }
    }
    var headers = {
      "Content-Type": "application/json",
      token: token,
    };

    axios
      .get(apiBaseUrl, { headers: headers })
      .then(function(response) {
        if (response.status === 200) {
          if (
            response.data.status != "ready to download" ||
            response.data.status === "proccessing file" ||
            response.data.status === "Genrating File still in progress"
          ) {
            x.setState({
              displayViewBox:true
            });
            x.exportDataInterval();
          } else if (response.data.status === "ready to download") {
            var collectionName = response.data.file_name;
            if (ip.includes(s2)) {
              window.location =
                API_BASE_URL + "/core/user/rest/Export/" +
                collectionName +
                "/download";
            } else {
              window.location =
                API_BASE_URL +
                "/core/user/rest/Export/" +
                collectionName +
                "/download";
            }
            x.setState({
              displayViewBox:false
            })
          }
        } else if (response.status === 204) {
          console.log("Something wrong");
        } else {
          console.log("Something wrong");
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  };
  exportDataInterval = (e) => {
    var exportcall = setInterval(function() {
      var token = reactLocalStorage.get("accessToken");
      var user_id = reactLocalStorage.get("user_id_login");
      var user_name = reactLocalStorage.get("email_login");
      var ip = API_BASE_URL;
      var s2 = "localhost:3000";
      var apiBaseUrl;
      if (reactLocalStorage.get("role") === "ROLE_OPERATOR") {
        var collectionName = "corpsms_request";
        var query = {
          file_id: user_id,
          toUserName: reactLocalStorage.get("userNameLoggedIN"),
          to: "zainUniCam",
        };
        query = encodeURI(JSON.stringify(query));
        var x = this;
        if (ip.includes(s2)) {
          apiBaseUrl =
            API_BASE_URL + "/core/user/rest/Export/" +
            collectionName +
            "?query=" +
            query;
        } else {
          apiBaseUrl =
            API_BASE_URL +
            "/core/user/rest/Export/" +
            collectionName +
            "?query=" +
            query;
        }
      } else {
        var collectionName = "corpsms_request";
        var query = {
          file_id: user_id,
          toUserName: reactLocalStorage.get("userNameLoggedIN"),
        };
        query = encodeURI(JSON.stringify(query));
        var x = this;
        if (ip.includes(s2)) {
          apiBaseUrl =
            API_BASE_URL + "/core/user/rest/Export/" +
            collectionName +
            "?query=" +
            query;
        } else {
          apiBaseUrl =
            API_BASE_URL +
            "/core/user/rest/Export/" +
            collectionName +
            "?query=" +
            query;
        }
      }
      var headers = {
        "Content-Type": "application/json",
        token: token,
      };

      axios
        .get(apiBaseUrl, { headers: headers })
        .then(function(response) {
          if (response.status === 200) {
            if (
              response.data.status != "ready to download" ||
              response.data.status === "proccessing file" ||
              response.data.status === "Genrating File still in progress"
            ) {
              x.setState({
                displayViewBox:true
              })
            } else if (response.data.status === "ready to download") {
              clearInterval(exportcall);
              const viewBoxEl = document.querySelector(".viewBox");
              if (viewBoxEl) {
                viewBoxEl.style.display = "none";
              }
              var collectionName = response.data.file_name;
              if (ip.includes(s2)) {
                window.location =
                  API_BASE_URL + "/core/user/rest/Export/" +
                  collectionName +
                  "/download";
              } else {
                window.location =
                  API_BASE_URL +
                  "/core/user/rest/Export/" +
                  collectionName +
                  "/download";
              } x.setState({
                displayViewBox:false
              })
            }
          } else if (response.status === 204) {
            console.log("Something wrong");
          } else {
            console.log("Something wrong");
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }, 5000);
  };

  //---------------------------Add Request  functions ---------------------------//
  handleChangebalance = (event) => {
    console.log(this.state.balance)
    this.setState({ balance: event.target.value });
    console.log(this.state.balance)
  };

  handleChange = (event) => {
    this.setState({ request: event.target.value });
  };

  onChange = (values) => {
    this.setState({ typeselect: values.value });
  };

  Add() {
    if (reactLocalStorage.get("role") === "ROLE_ADMIN") {
      type = "sender_id";
    }

    this.setState({ modalOpenAdd: true });
  }
  handleSubmit = (event) => {
    
    console.log(this.state.typeselect,this.state.balance,'this.state.typeselect')
    event.preventDefault();
    var data;
    if (type === "balance") {
      if(this.state.balance==''||  this.state.balance==null || this.state.typeselect=='' || this.state.typeselect==null ){
        toast({
          type: "error",
          title: i18n.t("error.label"),
          
          description: i18n.t("Please_fill_all_fields.label"),
          animation: "bounce",
          time: 5000,
        });
      }else{
      data = {
        type: "balance",
        balance_type: this.state.typeselect,
        value: this.state.balance,
      };
      this.callRequest(data)
    
    }
    } else if (type === "sender_id") {
      if(this.state.request=='' || this.state.request ==null){
        toast({
          type: "error",
          title: i18n.t("error.label"),
          
          description: i18n.t("Please_fill_all_fields.label"),
          animation: "bounce",
          time: 5000,
        });
      } else{
      data = {
        type: "sender_id",
        value: this.state.request,
        isAdv: this.state.enable,
      };
      this.callRequest(data)
    }
    }
   
  };

  callRequest=(data)=>{
    var token = reactLocalStorage.get("accessToken");
    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl = API_BASE_URL + "/core/corpsms/request";
    } else {
      apiBaseUrl = API_BASE_URL + "/core/corpsms/request";
    }
    var headers = {
      "Content-Type": "application/json",
      token: token,
    };
    axios
      .post(apiBaseUrl, data, { headers: headers })
      .then(function(response) {
        if (response.status === 200) {
          if (response.data.status === "success") {
            window.location = "RequestBalance";
          }
          if(response.data.status=='failed'){
            toast({
              type: "error",
              title: i18n.t("error.label"),
              description: response.data.result.ErrorDescription,
              animation: "bounce",
              time: 5000,
            });
          }
        } else if (response.status === 204) {
          console.log("Something wrong");

          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Something_wrong.label"),
            animation: "bounce",
            time: 5000,
          });
        } else {
          console.log("Something wrong");
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Something_wrong.label"),
            animation: "bounce",
            time: 5000,
          });
        }
      })
      .catch(function(error) {
        console.log(error);
        toast({
          type: "error",
          title: i18n.t("error.label"),
          description: i18n.t("Something_wrong.label"),
          animation: "bounce",
          time: 5000,
        });
      });
  }
  onChangetype = (event) => {
    if (event.label === "Sender_ID" || event.label === "هوية المرسل") {
      type = "sender_id";
      const senderRequestEl = document.querySelector(".sender_request");
      if (senderRequestEl) {
        senderRequestEl.style.display = "block";
      }
      const balanceRequestEl = document.querySelector(".balance_request");
      if (balanceRequestEl) {
        balanceRequestEl.style.display = "none";
      }
    } else if (event.label === "Balance" || event.label === "رصيد") {
      type = "balance";
      const senderRequestEl = document.querySelector(".sender_request");
      if (senderRequestEl) {
        senderRequestEl.style.display = "none";
      }
      const balanceRequestEl = document.querySelector(".balance_request");
      if (balanceRequestEl) {
        balanceRequestEl.style.display = "block";
      }
    }
  };
  Adv = (event) => {
    if (this.state.enable === false) {
      this.setState({ enable: true });
    } else {
      this.setState({ enable: false });
    }
  };

  confirm_msg = (event) => {
    
    
    let currentComponent = this;
    var id = this.state.idRecord;
    var token = reactLocalStorage.get("accessToken");

    var ip = API_BASE_URL;
    var s2 = "localhost:3000";
    var apiBaseUrl;
    if (ip.includes(s2)) {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/confirmSMS/" +
        this.state.confirm_id;
    } else {
      apiBaseUrl =
        API_BASE_URL + "/core/user/rest/jobs/confirmSMS/" + this.state.confirm_id;
    }

    var data = {};
    axios
      .post(apiBaseUrl, data, {
        headers: { "Content-Type": "application/json", token: token },
      })
      .then(function(response) {
        if (response.status === 200) {
          if (response.data.result != undefined) {
            if (response.data.status === "saved successfully!") {
            //  currentComponent.setState({ modalOpenApproveSMS: false });
            //window.location = "RequestBalance";

              ////////////////////////////////////////////////////////////////
              var headers = {
                "Content-Type": "application/json",
                token: token,
              };
             
            
                      var data = {};
          
                      var token = reactLocalStorage.get("accessToken");
                      var ip = API_BASE_URL;
                      var s2 = "localhost:3000";
                      var apiBaseUrl;
                      if (ip.includes(s2)) {
                        apiBaseUrl =
                          API_BASE_URL + "/core/corpsms/updaterequest/" +
                          id +
                          "/Approved";
                      } else {
                        apiBaseUrl =
                          API_BASE_URL +
                          "/core/corpsms/updaterequest/" +
                          id +
                          "/Approved";
                      }
                      var headers = {
                        "Content-Type": "application/json",
                        token: token,
                      };
                      axios
                        .post(apiBaseUrl, data, { headers: headers })
                        .then(response=>{
                          if (response.status === 200) {
                            if (response.data.status === "success") {
                          
                              window.location = "RequestBalance";
                            }
                            if (response.data.status === "failed") {
                              toast({
                                type: "warning",
                                title: "Warning",
                                description:
                                  response.data.result.ErrorDescription,
                                animation: "bounce",
                                time: 5000,
                              });
                            }
                          } else {
                            console.log("Something wrong");
                            console.log('test')
                            toast({
                              type: "error",
                              title: i18n.t("error.label"),
                              description: i18n.t("Something_wrong.label"),
                              animation: "bounce",
                              time: 5000,
                            });
                          }
                        });     
             
            } else {
              toast({
                type: "error",
                title: i18n.t("error.label"),
                description: i18n.t("Something_wrong.label"),
                animation: "bounce",
                time: 5000,
              });
            }
          }
        } else if (response.status === 204) {
          
          toast({
            type: "error",
            title: i18n.t("error.label"),
            description: i18n.t("Something_wrong.label"),
            animation: "bounce",
            time: 5000,
          });
        }
      })
      // .catch(function(error) {
      //   console.log(error);
      //   toast({
      //     type: "error",
      //     title: i18n.t("error.label"),
      //     description: i18n.t("Something_wrong.label"),
      //     animation: "bounce",
      //     time: 5000,
      //   });
      // });
  };



  render() {
    const { activePage } = this.state;
    const { open, dimmer } = this.state;
    return (
      <div className="big_div">
        <Menutest />
        <div className="actionMenu">
          <div className="main_div_request">
            <div className="main_request">
              <Grid columns={2} divided className="fixed_request">
                <Grid.Row stretched className="fixed_header">
                  <Grid.Column className="grid_logo">
                    <Segment>
                      <h3 className="text_style azr2_fate7_color">
                        {this.state.isArabic ? (
                          <img
                            src={require("../pictures/ArabicHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginTop: "8px",
                              marginRight: "-13px",
                            }}
                            className="himage"
                          />
                        ) : (
                          <img
                            src={require("../pictures/EnglishHedar.png")}
                            style={{
                              width: "100% !important",
                              height: "117px",
                              marginLeft: "-13px",
                              marginTop: "8px",
                            }}
                            className="himage"
                          />
                        )}
                      </h3>
                    </Segment>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>
          <br />
          <br />
          <br />
          <br />
          <div
            className="container_cards"
            style={{ paddingRight: this.state.isArabic ? "" : "20px" }}
          >
            <div
              className={
                this.state.isArabic ? "content_reportarabic" : "content_report"
              }
            >
              <br />
              <Segment
                color="black"
                style={{ padding: "20px", minHeight: "200px" }}
              >
                <br />
                <Divider horizontal>
                  {" "}
                  <Header as="h2" color="black">
                    <Icon name="list" color="black" />{" "}
                    {this.state.isArabic
                      ? "   معلومات طلب الرصيد "
                      : "Requests Information"}{" "} 
                  </Header>{" "}
                </Divider>
                { this.state.displayViewBox && <div className="viewBox ">
                
                <Message icon className="download_box">
                  <Icon name="circle notched" loading />
                  <Message.Content>
                    <Message.Header>Wait for downloading</Message.Header>
                    {this.state.viewData}
                  </Message.Content>
                </Message>
              </div>}
                <br />
                <div className="buttonsHeader">
                  <Input
                    size="small"
                    icon="search"
                    color="black"
                    placeholder={
                      this.state.isArabic
                        ? "البحث عن رقم "
                        : "Search By Number "
                    }
                    onChange={this.searchchange.bind(this)}
                    style={{ float: "right" }}
                  />
                  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={this.handleOpenFilterDetails}
                  >
                    <Icon name="sort amount up" /> {i18n.t("filter.label")}
                  </Button>

                  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    size="small"
                    onClick={() => {
                      this.componentWillMount();
                    }}
                  >
                    <Icon name="refresh" />{" "}
                    {this.state.isArabic ? "تحديث" : "Refresh"}
                  </Button>

                  <Button
                    floated="right"
                    icon
                    labelPosition="left"
                    basic
                    disabled={this.state.exportFlag === false ? true:false }
                    size="small"
                    onClick={this.exportData}
                  >
                    <Icon
                      name="file excel"
                      onClick={this.exportData}
                      color="black"
                    />{" "}
                    {i18n.t("export.label")}
                  </Button>

                  {reactLocalStorage.get("role") === "ROLE_OPERATOR" ||
                  reactLocalStorage.get("role") === "ROLE_OPERATOR_INT" ? (
                    ""
                  ) : (
                    <Button
                      floated="right"
                      icon
                      labelPosition="left"
                      basic
                      size="small"
                      onClick={this.handleOpenAdd}
                    >
                      {this.state.isArabic ? " طلب جديد" : " New Request"}
                      <Icon name="pencil alternate" color="black" />{" "}
                    </Button>
                  )}
                </div>
                <br /> <br />
                <br />
                <Table
                  hover
                  responsive
                  border="0"
                  style={{ textAlign: this.state.isArabic ? "right" : "left" }}
                >
                  <thead className="head">
                    <tr>
                      <th>{i18n.t("from.label")}</th>
                      <th>{i18n.t("to.label")}</th>
                      <th>{i18n.t("type.label")}</th>
                      <th>{i18n.t("value.label")}</th>
                      <th>{i18n.t("Status.label")}</th>
                      <th>{i18n.t("time.label")}</th>
                      <th>{i18n.t("view_details.label")}</th>
                    </tr>
                  </thead>
                  <tbody response>
                    {this.state.data.map((person) => (
                      <tr>
                        <td>{person.fromUserName} </td>
                        <td>{person.toUserName}</td>
                        <td > {person.type}</td>
                        <td>{person.value}</td>
                        <td>{person.status}</td>
                        <td>
                          {person.created_time
                            ? this.test(person.created_time)
                            : ""}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {" "}
                          {person.status === "pending" ? (
                            <Icon
                            className="eye"
                              name="eye"
                              id={person.id}
                              onClick={()=>{
                               person.type  ==="send_sms" ?
                               this.viewdataApprove( 
                                person.id,
                                person.confirm_id,
                                person.invalid_numbers_count,
                                person.valid_numbers_count,
                                person.total_messages,
                                person.balance_reserved,
                                person.status,
                                person.content
                               )

                                :
                               
                                 ( this.viewdata(
                                   
                                    person.id,
                                    person.balance_type,
                                    person.type,
                                    person.value,
                                    person.type,
                                    person.from,
                                    person.to,
                                    person.adv,
                                    person.status)
                                 )
                                
                                  }
                                }
                            />
                          ) : (
                            <Icon name="eye" disabled />
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <br />
                <br />
               
                
                <div className="pagination">
                  <Segment basic />
                  <Divider horizontal>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    >
                      <Pagination
                        defaultActivePage={1}
                        onPageChange={this.state.flag==="true" ? this.handlePaginationSearchChange : this.handlePaginationChange}
                        totalPages={this.state.totalpage}
                        className="page"
                      />
                    </Header>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    />
                  </Divider>
                </div>
                
                <div className="filterpagination" style={{ display: "none" }}>
                  <Segment basic />

                  <Divider horizontal>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    >
                      <Pagination
                        defaultActivePage={1}
                        onPageChange={this.handlePaginationFilterChange}
                        totalPages={this.state.filterTotalpage}
                        className="page"
                        floated={this.state.isArabic ? "left" : "right"}
                      />
                    </Header>
                    <Header
                      as="h5"
                      floated={this.state.isArabic ? "left" : "right"}
                    />
                  </Divider>
                </div>
              </Segment>
            </div>
          </div>

          <Modal
           closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
            size="tiny"
            className="add"
            open={this.state.modalOpenAdd}
            onClose={this.handleCloseAdd}
            style={reactLocalStorage.get("lang") === "ar" ? modadda : modadd}
          >
            <Header
              content={this.state.isArabic ? "إضافة طلب" : "Add Requests"}
            />
            <Modal.Content>
              <p style={{ fontSize: "14px" }}>
                {i18n.t("type_of_request.label")}
              </p>

              {reactLocalStorage.get("role") === "ROLE_SUBADMIN" ? (
                <Select
                  fluid
                  search
                  selection
                 
                  options={this.state.type_request}
                  onChange={this.onChangetype.bind(this)}
                  className="type_request"
                />
              ) : (
                ""
              )}

              <br />
              {reactLocalStorage.get("role") === "ROLE_ADMIN" ? (
                <Select
                  fluid
                  search
                  selection
                  options={this.state.type_request_admin}
                  
                  onChange={this.onChangetype.bind(this)}
                  id="type_request_admin"
                  style={{ display: "none" }}
                />
              ) : (
                ""
              )}

              <br />

              <div className="balance_request" style={{ display: "none" }}>
                <p className="h6 black_color type_ar">{i18n.t("type.label")}</p>
                <Select
                  fluid
                  search
                  selection
                  options={this.state.type}
                  onChange={this.onChange.bind(this)}
                />
                <br />
                <label
                  htmlFor="defaultFormCardNameEx"
                  className="grey-text font-weight-light balance_ar"
                >
                  {i18n.t("balance.label")}
                </label>
                <input
                  type="number"
                  id="defaultFormCardNameEx"
                  className="form-control"
                  name="balance"
                  onChange={(e) => {
                    const re = /^[0-9\b]+$/;
                    if (e.target.value === '' || re.test(e.target.value)) {
                  
                      this.handleChangebalance(e)
                   }
                    
                  }
                }
                  //onChange={this.handleChangebalance}
                />
                <br />
              </div>

              <div className="sender_request" style={{ display: "none" }}>
                <br />
                <label
                  htmlFor="defaultFormCardNameEx"
                  className="grey-text font-weight-light title_req"
                >
                  {i18n.t("Request_Sender_ID.label")}
                </label>
                <input
                  type="text"
                  id="defaultFormCardNameEx"
                  className="form-control"
                  name="requwat"
                  onChange={this.handleChange}
                  maxLength="11"
                  value={this.state.request}
                />
                <br />
                <div class="ui checkbox">
                <input type="checkbox" name="example" onClick={this.Adv} style={{color:'blue'}} />
                <label>{i18n.t("Adv.label")}</label>
              </div>
               
              </div>
            </Modal.Content>
            <Modal.Actions>
              <Button
                basic
                color="teal"
                content={i18n.t("Submit.label")}
                onClick={this.handleSubmit}
              />
              <Button
                basic
                color="black"
                content={i18n.t("Cancel.label")}
                onClick={this.handleCloseAdd}
              />
            </Modal.Actions>
          </Modal>
          <Modal
           closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
            size="small"
            style={reactLocalStorage.get("lang") === "ar" ? moda : mod}
            className="add"
            open={this.state.modalOpen}
            onClose={this.handleClose}
          >
            <Header
              icon="clipboard list outline"
              content={i18n.t("view_details.label")}
            />
            <Modal.Content>
              <Form floated={this.state.isArabic ? "right" : "left"}>
                <Form.Input
                  fluid
                  label={i18n.t("from.label")}
                  placeholder="From"
                  value={this.state.from}
                />
                <Form.Input
                  fluid
                  label= {this.state.sender ==="sender_id"?i18n.t("new_Request_SenderID.label"):i18n.t("new_Request_Balance.label")}   
                  placeholder="Request Sender ID"
                  value={this.state.sender}
                />
               { /*************************************************************** New 10/7/2023 *************************************************************/}
                { this.state.balance_type_request != null? <Form.Input
                  fluid
                  label={i18n.t("balance_Type.label")}
                  placeholder={i18n.t("balance_Type.label")}
                  value={this.state.balance_type_request}
                />
                :null
                
                }
                {/******************************************************************************************************************************************/}
                 <div class="ui checkbox">
                  <input type="checkbox" name="example" checked={
                      this.state.account_status_value === true ? true : false
                    } onClick={this.Adv} style={{color:'blue'}} />
                  <label>{i18n.t("Adv.label")}</label>
                 </div>

                {/* <Checkbox
                  label={i18n.t("adv.label")}
                  onClick={this.Adv}
                  id="data_check"
                  checked={
                    this.state.account_status_value === true ? true : false
                  }
                /> */}
              </Form>
            </Modal.Content>
            <Modal.Actions>
           {/*  {reactLocalStorage.get('role')==="ROLE_SUBADMIN" || "ROLE_ADMIN" ? (""): 
              reactLocalStorage.get('role')==="ROLE_OPERATOR "?( 
                <Button
                basic
                color="teal"
                content={i18n.t("approve.label")}
                onClick={(this.handleClose, this.handleOpenApprove)}
              />):("")} */}
             
               {reactLocalStorage.get('role')==="ROLE_OPERATOR" || ( reactLocalStorage.get('role')==="ROLE_ADMIN"  && this.state.hideApprove==false)?  (
                <Button
                basic
                color="teal"
                content={i18n.t("approve.label")}
                onClick={(this.handleClose, this.handleOpenApprove)}
              />): ("")}
              {reactLocalStorage.get('role')==="ROLE_SUBADMIN"  ? (""): (
              <Button
                basic
                color="black"
                content={i18n.t("reject.label")}
                onClick={(this.handleClose, this.handleOpenReject)}
              />)}
              <Button
                basic
                color="black"
                content={i18n.t("Close.label")}
                onClick={this.handleClose}
              />
            </Modal.Actions>
          </Modal>
          <Modal
           closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
            size="tiny"
            className="add"
            open={this.state.modalOpenReject}
            onClose={this.handleCloseReject}
            style={reactLocalStorage.get("lang") === "ar" ? modai : modi}
          >
            <Header
              icon="warning circle"
              content={
                reactLocalStorage.get("lang") === "ar"
                  ? "رفض الطلب"
                  : "Reject Request"
              }
            />
            <Modal.Content>
              <Header as="h3" textAlign="center">
                {" "}
                {i18n.t("Are_you_sure_you_want_to_reject_this_request.label")}
              </Header>
            </Modal.Content>
            <Modal.Actions>
              <Button
                basic
                color="teal"
                content={reactLocalStorage.get("lang") === "ar" ? "نعم" : "Yes"}
                onClick={this.rejectRequest}
              />
              <Button
                basic
                color="black"
                content={reactLocalStorage.get("lang") === "ar" ? "لا" : "No"}
                onClick={this.handleCloseReject}
              />
            </Modal.Actions>
          </Modal>
          <Modal
           closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
            size="tiny"
            className="add"
            open={this.state.modalOpenApprove}
            onClose={this.handleCloseApprove}
            style={reactLocalStorage.get("lang") === "ar" ? modai : modi}
          >
            <Header
              icon="warning circle"
              content={
                reactLocalStorage.get("lang") === "ar"
                  ? "تأكيد اطلب"
                  : "Approve Request"
              }
            />
            <Modal.Content>
              <Header as="h3" textAlign="center">
                {" "}
                {i18n.t("Are_you_sure_you_want_to_approve_this_request.label")}
              </Header>
            </Modal.Content>
            <Modal.Actions>
              <Button
                basic
                color="teal"
                content={reactLocalStorage.get("lang") === "ar" ? "نعم" : "Yes"}
                onClick={this.confirmRequest}
              />
              <Button
                basic
                color="black"
                content={reactLocalStorage.get("lang") === "ar" ? "لا" : "No"}
                onClick={this.handleCloseApprove}
              />
            </Modal.Actions>
          </Modal>
          {/* ////////////////////////////////// filter////////////////////////////////*/}
          <Modal
           closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
            size="large"
            open={this.state.modalOpenFilterDetails}
            onClose={this.handleCloseFilterDetails}
            className="add"
            style={this.state.isArabic ? filtera : filter}
          >
            <Header content="Filter" />
            <Modal.Content scrolling>
              <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
                style={{ float: this.state.isArabic ? "right" : "left" }}
              >
                {i18n.t("start_date.label")}
              </label>
              <br />
              <input
                type="date"
                onChange={this.onChangeFromDate}
                className="dateinput"
              />

              <br />

              <label
                htmlFor="defaultFormCardNameEx"
                className="grey-text font-weight-light"
                style={{ float: this.state.isArabic ? "right" : "left" }}
              >
                <br />
                {i18n.t("end_date.label")}
              </label>
              <input
                type="date"
                onChange={this.onChangeToDate}
                className="dateinput"
              />

              <br />
            </Modal.Content>
            <Modal.Actions>
              <Button
                basic
                color="teal"
                content={i18n.t("Submit.label")}
                onClick={() => {
                  this.filterData();
                }}
              />
              <Button
                basic
                color="black"
                content={i18n.t("Cancel.label")}
                onClick={this.handleCloseFilterDetails}
              />
            </Modal.Actions>
          </Modal>

          <Modal
           closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
            size="small"
            style={reactLocalStorage.get("lang") === "ar" ? modaapprove : modapprove}
            className="add"
            open={this.state.modalOpenApproveSMS}
            onClose={this.handleCloseApproveSMS}
          >
            <Header
              icon="clipboard list outline"
              content={i18n.t("view_details.label")}
            />
            <Modal.Content scrolling>
              <Form floated={this.state.isArabic ? "right" : "left"}>
               
              <Form.Input
                    label={this.state.isArabic?'نوع الرسالة':'Message Type'}
                   value={this.state.messageType}
                    style={{
                      textAlign:
                        reactLocalStorage.get("lang") === "ar"
                          ? "right"
                          : "left",
                    }}
              />

              <Form.Input
                    label={i18n.t("totalmsg.label")}
                   value={this.state.total_messages}
                    style={{
                      textAlign:
                        reactLocalStorage.get("lang") === "ar"
                          ? "right"
                          : "left",
                    }}
                  />

                  <Form.Input
                    label={i18n.t("totalValid_Number.label")}
                   value={this.state.valid_numbers_count}
                    style={{
                      textAlign:
                        reactLocalStorage.get("lang") === "ar"
                          ? "right"
                          : "left",
                    }}
                  />

                  <Form.Input
                    label={i18n.t("totalinValid_Number.label")}
                    value={this.state.invalid_numbers_count}
                    style={{
                      textAlign:
                        reactLocalStorage.get("lang") === "ar"
                          ? "right"
                          : "left",
                    }}
                  />

                  <Form.Input
                    label={i18n.t("balance_reserved.label")}
                   value={this.state.balance_reserved}
                    style={{
                      textAlign:
                        reactLocalStorage.get("lang") === "ar"
                          ? "right"
                          : "left",
                    }}
                  />

                   <textarea
                      className="form-control templates-class textarea_content"
                      id="contentArea"
                      name="mobile"
                      required="required"
                      onChange={this.handleChangeContent}
                      value={this.state.content}
                    />


              </Form>
            </Modal.Content>
            <Modal.Actions>
            {reactLocalStorage.get('role')==="ROLE_SUBADMIN" ? (""): (
              <Button
                basic
                color="teal"
                content={i18n.t("approve.label")}
                onClick={(this.handleClose, this.handleOpenApprovesms)}
              />)}
              {reactLocalStorage.get('role')==="ROLE_SUBADMIN" ? (""): (
              <Button
                basic
                color="black"
                content={i18n.t("reject.label")}
                onClick={(this.handleClose, this.handleOpenReject)}
              />)}
              <Button
                basic
                color="black"
                content={i18n.t("Close.label")}
                onClick={this.handleCloseApproveSMS}
              />
            </Modal.Actions>
          </Modal>

          <Modal
           closeIcon={{ style: { top: '0rem', right: '0rem' }, color: 'black', name: 'close' }}
            size="tiny"
            className="add"
            open={this.state.modalOpenApprovesms}
            onClose={this.handleCloseApprovesms}
            style={reactLocalStorage.get("lang") === "ar" ? modai : modi}
          >
            <Header
              icon="warning circle"
              content={
                reactLocalStorage.get("lang") === "ar"
                  ? "تأكيد اطلب"
                  : "Approve Request"
              }
            />
            <Modal.Content>
              <Header as="h3" textAlign="center">
                {" "}
               
                {i18n.t("Are_you_sure_you_want_to_approve_this_request.label")}
              </Header>
            </Modal.Content>
            <Modal.Actions>
              <Button
                basic
                color="teal"
                content={reactLocalStorage.get("lang") === "ar" ? "نعم" : "Yes"}
                onClick={this.confirm_msg}
              />
              <Button
                basic
                color="black"
                content={reactLocalStorage.get("lang") === "ar" ? "لا" : "No"}
                onClick={this.handleCloseApprovesms}
              />
            </Modal.Actions>
          </Modal>

          <SemanticToastContainer />
         
        </div>{" "}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return { ...state };
};
export default connect(mapStateToProps)(RequestBalance);
